
enum SurveyEvents {
    // アンケート情報取得
    LoadSurveyByIdStarted = "[SurveyEvents] LoadSurveyByIdStarted",
    LoadSurveyByIdComplete = "[SurveyEvents] LoadSurveyByIdComplete",
    // アンケート回答登録
    AddSurveyAnswerStarted = "[SurveyEvents] AddSurveyAnswerStarted",
    AddSurveyAnswerComplete = "[SurveyEvents] AddSurveyAnswerComplete",
    AddSurveyAnswerFailed = "[SurveyEvents] AddSurveyAnswerFailed",
    // 全アンケート情報取得
    GetAllSurveyStarted = "[SurveyEvents] GetAllSurveyStarted",
    GetAllSurveyComplete = "[SurveyEvents] GetAllSurveyComplete",
    // アンケート追加
    AddSurveyStarted = "[SurveyEvents] AddSurveyStarted",
    AddSurveyComplete = "[SurveyEvents] AddSurveyComplete",
    // アンケート更新
    UpdateSurveyStarted = "[SurveyEvents] UpdateSurveyStarted",
    UpdateSurveyComplete = "[SurveyEvents] UpdateSurveyComplete",
    UpdateSurveyFailed = "[SurveyEvents] UpdateSurveyFailed"
}

export default SurveyEvents;
